<template>
  <div class="container">
    <div id="header" class="flex flex-row-left  margin-top-20 ">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="单号">
            <el-input type="textarea" style="width:200px" v-model="formInline.number" placeholder="请输入物流单号,换行查询多个" clearable />
          </el-form-item>
          <el-form-item label="订单号">
            <el-input  style="width:200px" v-model="formInline.platformOrderId" placeholder="请输入订单号/移货订单号" clearable />
          </el-form-item>
          <el-form-item label="SKU">
            <el-input  style="width:200px" v-model="formInline.SKU" placeholder="请输入SKU信息" clearable />
          </el-form-item>

          <el-form-item label="操作仓库">
            <el-select
                v-model="formInline.warehouseId"
                filterable
                clearable
                @clear="formInline.warehouseId=''"
                :placeholder="请选择操作仓库"
                remote-show-suffix
                class="mobile-select"
                @change="handleChange"
            >
              <el-option
                  v-for="item in stockList"
                  :key="item.warehousefCode"
                  :label="item.warehouseName"
                  :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="操作时间">
            <el-date-picker
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.startMonth"
                type="date"
                placeholder="操作时间"
                clearable
                @clear="formInline.startMonth=''"
            />
            -
            <el-date-picker
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.endMonth"
                type="date"
                placeholder="操作时间"
                clearable
                @clear="formInline.endMonth=''"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="onSubmits">导出Excel</el-button>
          </el-form-item>

        </el-form>
      </div>

    </div>

    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
            row-key="id"
            :lazy="true"
            :load="load"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            empty-text="请点击查询">
          <el-table-column
              label="操作类型"
              min-width="120"
              prop="operationType"
          ></el-table-column>
          <el-table-column
              label="签收/发货/维修流水号"
              min-width="100"
              prop="uniPlatformId"
          ></el-table-column>
          <el-table-column
              label="物流单号"
              min-width="100"
              prop="trackNumber"
          ></el-table-column>
          <el-table-column
              label="中台签收/发货数量"
              min-width="100"
              prop="quantity"
          ></el-table-column>
          <el-table-column
              label="中台签收/发货仓库"
              min-width="100"
              prop="warehouseName"
          ></el-table-column>
          <el-table-column
              label="退货类型"
              min-width="100"
              prop="returnType"
          ></el-table-column>
          <el-table-column
              label="马帮退货单号/移货订单号"
              min-width="100"
              prop="originalOrderNumber"
          ></el-table-column>
          <el-table-column
              label="产品SKU"
              min-width="100"
              prop="materSku"
          ></el-table-column>
          <el-table-column
              label="产品名称"
              min-width="100"
              prop="materName"
          ></el-table-column>
          <el-table-column
              label="入库流水号"
              min-width="80"
              prop="signNumber"
          ></el-table-column>
          <el-table-column
              label="马帮签收/发货数量"
              min-width="80"
              prop="orderQuantity"
          ></el-table-column>

          <el-table-column
              label="马帮签收仓库"
              min-width="80"
              prop="signWarehouseName"
          ></el-table-column>
          <el-table-column
              label="签收仓库"
              min-width="80"
              prop="signWarehouseName"
          ></el-table-column>
          <el-table-column
              label="马帮签收时间"
              min-width="80"
              prop="mbSingTime"
          ></el-table-column>
          <el-table-column
              label="入库类型"
              min-width="80"
              prop="inStoreType"
          ></el-table-column>
          <el-table-column
              label="马帮入库/出库类型"
              min-width="80"
              prop="inOrOutType"
          ></el-table-column>
          <el-table-column
              label="中台操作时间"
              min-width="80"
              prop="signTime"
          ></el-table-column>
          <el-table-column
              label="出/入库批次号"
              min-width="80"
              prop="maOrder"
          ></el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>
  </div>
</template>
<script>
import {ElForm,ElFormItem,ElButton,ElInput,ElDatePicker,ElTable,

  ElTableColumn,ElPagination,ElSelect,ElOption} from "element-plus";

import {getAllSignAndInstoreLog} from "@/utils/api";
import {baseUrl}  from "../../../src/utils/requset.js"
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
import {getLocalStockList} from "../../../public/js";

export default {
  name: "allSignAndInstoreLog",
  mixins:[DynamicHeightMixin],
  components: {ElForm,ElFormItem,ElButton,ElInput,ElDatePicker,ElTable,ElSelect,ElOption,
    ElTableColumn,ElPagination},
  data(){
    return{
      formInline:{
      },
      tableData:[],
      stockList:[],
      currentPage:1,
      pageTotal:0,
      pageSize:20,
    }
  },
  beforeMount() {
    // 是否启用自动查询
    // this.getReceipt();
    this.getLocalStockList()
  },
  methods:{
    getLocalStockList(){
      getLocalStockList().then(res => {
        this.stockList = res.filter(item=>{
          return item.warehouseName.includes("美国售后仓")
        })
      })
    },
    onSubmit(){
      this.PageNumber = 1
      this.getReceipt()
    },
    onSubmits(){
      let pramas = Object.entries(this.formInline)
          .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
          .join('&');
      let url = baseUrl + 'after/allSignAndInstoreLogExport?'+ pramas

      window.open(url)
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getReceipt();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getReceipt();
    },
    getReceipt(){
      getAllSignAndInstoreLog({...this.formInline,PageSize:this.pageSize,PageNumber:this.currentPage}).then(res=>{
        this.tableData = res.Data
        this.pageTotal = res.Total
      }).catch(res=>{
        console.log(res)
      })
    },
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
::v-deep .container {
  .el-form-item{
    margin-bottom:0!important;
  }
}
::v-deep .el-select .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}

::v-deep .el-select .el-select__tags .el-tag {
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep .el-table .el-table__cell{
  box-sizing: border-box;
  min-width: 0;
  padding: 8px 0;
  position: relative;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  z-index: unset !important;
}
.pagination{
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-button+.el-button {
  margin-left: 0px;
}
</style>